import validate from "/var/www/rare-database/node_modules/.pnpm/nuxt@3.15.4_@types+node@18.19.79_less@4.2.2_terser@5.39.0_typescript@5.8.2_vite@6.2.0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _2_45language_45global from "/var/www/rare-database/middleware/2.language.global.ts";
import access_45global from "/var/www/rare-database/middleware/access.global.ts";
import auth_45global from "/var/www/rare-database/middleware/auth.global.ts";
import manifest_45route_45rule from "/var/www/rare-database/node_modules/.pnpm/nuxt@3.15.4_@types+node@18.19.79_less@4.2.2_terser@5.39.0_typescript@5.8.2_vite@6.2.0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _2_45language_45global,
  access_45global,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}